import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import myConfig from "../../configs/config";
import { Form, FormGroup, Label, Input, Alert } from "reactstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import logoIcon from "../../assets/images/logo.png";

const DEV_LOGIN_EMAIL = process.env.REACT_APP_DEV_LOGIN_EMAIL || "";
const DEV_LOGIN_PASSWORD = process.env.REACT_APP_DEV_LOGIN_PASSWORD || "";
const IS_DEV = process.env.NODE_ENV === "development";

const Login = (props) => {
  document.title = "Agriconnected - Entrar";

  const [email, setEmail] = useState(IS_DEV ? DEV_LOGIN_EMAIL : "");
  const [password, setPassword] = useState(IS_DEV ? DEV_LOGIN_PASSWORD : "");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);

  function formData() {
    const form_data = new FormData();
    const resolvedPassword =
      password || (IS_DEV && DEV_LOGIN_PASSWORD ? DEV_LOGIN_PASSWORD : "");

    form_data.append("username", email);
    form_data.append("password", resolvedPassword);

    form_data.append("grant_type", "password");
    form_data.append("client_id", "api");
    form_data.append(
      "client_secret",
      "OdcffQR0bZVl4NDW1cXuvGpf1CmRxjyMyDxL7yWrGeIpbpSv5thpJKGDFWYkVUkTQfbllgJPmsixmM07yaozCcbWzuCXVoZ5qUpyKrH7gBI5KuyIAiMK1lcj4hzSPUQC"
    );

    return form_data;
  }

  function onSubmit(e) {
    e.preventDefault();

    const LOGIN_AGRICONNECTED = myConfig.BE_URL + "/o/token/";

    axios({
      baseURL: LOGIN_AGRICONNECTED,
      method: "post",
      data: formData(),
    })
      .then((response) => {
        if (response.status === 200) {
          localStorage.setItem("client-token", response.data.access_token);
          localStorage.setItem("refresh_token", response.data.refresh_token);
          let urlParams = new URLSearchParams(window.location.search);
          let next = urlParams.get("next");
          if (next == null) {
            next = "/";
          } else {
            next = decodeURIComponent(next);
          }
          window.location.href = next;
        }
      })
      .catch((error) => {
        if (!error.response) {
          setError(
            "Não foi possível conectar à API local. Verifique se ela está rodando em http://localhost:8080."
          );
        } else if (error.response.status === 500) {
          setError(
            "A API local retornou erro interno. Verifique se o banco de dados está rodando (docker compose up -d db) e tente novamente."
          );
        } else {
          const desc =
            error.response.data && error.response.data.error_description
              ? error.response.data.error_description
              : "Falha no login";
          setError("Error: " + desc);
        }
      });
    setTimeout(() => {
      setError(null);
    }, 3500);
  }

  let formError =
    error !== null ? <Alert color="danger"> {error} </Alert> : null;

  return (
    <div id="login_container">
      <div className="row" style={{ marginTop: "1vh" }}>
        <div className="col-md-offset-4 col-md-4 col-sm-offset-3 col-sm-6 col-xs-12">
          <div className="x_panel">
            <div className="x_content"></div>
            {formError}

            <h1 align="center">Entrar</h1>
            <Form onSubmit={onSubmit}>
              <FormGroup>
                <Label for="id_email">Endereço de e-mail</Label>
                <Input
                  type="email"
                  onChange={(e) => setEmail(e.target.value)}
                  name="email"
                  value={email}
                  className="form-control"
                  placeholder="Endereço de e-mail"
                  required
                  id="id_email"
                />
              </FormGroup>
              <FormGroup>
                <Label for="id_password">Senha</Label>
                <div className="login-password-wrap">
                  <Input
                    type={showPassword ? "text" : "password"}
                    onChange={(e) => setPassword(e.target.value)}
                    name="password"
                    value={password}
                    maxLength="35"
                    className="form-control"
                    placeholder="Senha"
                    required={!IS_DEV}
                    id="id_password"
                  />
                  <button
                    type="button"
                    className="login-password-toggle"
                    onClick={() => setShowPassword((v) => !v)}
                    title={showPassword ? "Ocultar senha" : "Mostrar senha"}
                    aria-label={
                      showPassword ? "Ocultar senha" : "Mostrar senha"
                    }
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </FormGroup>

              <div align="center">
                <Input
                  type="submit"
                  className="botao_login btn btn-primary"
                  value="Entrar"
                />
              </div>
            </Form>

            <div align="center">
              <Link
                to="/account/recovery/"
                className="to_register"
                align="center"
              >
                Esqueci minha senha
              </Link>

              <p className="change_link">
                Novo por aqui?
                <Link to="/account/signup/" className="to_register">
                  Crie uma conta
                </Link>
              </p>

              <div className="separator"></div>

              <div className="logo-agri">
                <img src={logoIcon} alt="logo-mini" className="logo-mini" />
              </div>

              <p>
                ©2019 Todos Direitos Reservados. Política de Privacidade e
                Termos de Uso
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
